import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { easeInOutTrigger } from 'app/animations';
import { UserContext } from 'app/core/store/session/user-context/user-context.interface';

@Component({
  selector: 'admin-user-edit-buttons',
  templateUrl: './user-edit-buttons.component.html',
  styleUrls: ['./user-edit-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
  animations: [easeInOutTrigger('easeInOut', 0)],
})
export class UserEditButtonsComponent {
  @Input() userId: string;
  @Input() userContext: UserContext;
  @Input() reInviting: boolean;
  @Input() resettingPassword: boolean;
  @Input() disabled: boolean;

  @Output() reInvite: EventEmitter<string> = new EventEmitter();
  @Output() resetPassword: EventEmitter<string> = new EventEmitter();
}
